/**
 * Die Erkennungsfarbe eines Projekts.
 *
 * Der Entwurf „Cubic Studio" setzt vor jeden Projektnamen einen farbigen
 * Punkt. Eine Farbe je Projekt gibt es fachlich nicht, und eine einzuführen
 * hieße, eine Spalte und eine Migration für etwas rein Dekoratives zu
 * verlangen. Sie wird deshalb aus der Kennung abgeleitet — wie die Farbe
 * hinter Initialen in einem Adressbuch.
 *
 * Zwei Eigenschaften sind dabei Bedingung: Dieselbe Kennung ergibt immer
 * dieselbe Farbe (sonst springt der Punkt bei jedem Neuladen), und alle Werte
 * liegen auf einem Ring gleicher Helligkeit und Sättigung (sonst sticht ein
 * Projekt heraus, weil sein Name zufällig eine grelle Zahl ergibt).
 */

/** Helligkeit und Buntheit des Entwurfs für Akzentpunkte. */
const HELLIGKEIT = 0.6;
const BUNTHEIT = 0.1;

export function farbtonZu(kennung: string): number {
  let summe = 0;
  for (let i = 0; i < kennung.length; i += 1) {
    // Position mitzählen, sonst ergeben Umstellungen dieselbe Farbe.
    summe = (summe * 31 + kennung.charCodeAt(i)) % 360;
  }
  return summe;
}

export function projektfarbe(kennung: string): string {
  return `oklch(${HELLIGKEIT} ${BUNTHEIT} ${farbtonZu(kennung)})`;
}
